<template>

     <form-group :validator="v" :label="label" :label-for="id" :description="tip"
        :messages="messages">
        <template slot-scope="{ attrs, listeners }">
            <b-form-radio-group
                :id="id"
                v-model="text"
                :options="options"
                :name="id"
                :aria-label="label"
                :data-test="slug"
                v-bind="attrs"
                :required="!v.required"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners"/>
        </template>
    </form-group>
    
</template>

<script>
import _ from "lodash"

export default {
    props: {
        value: [String, Number],
        v: [Object],
        label: [String],
        tip: [String],
        options: Array,
        slug: [String],
        setId: [String],
        messages: [Object]
    },

    computed: {
        id() {
            if (this.setId === null) {
                return _.uniqueId('radio')
            } else {
                return this.setId
            }
        },
        text: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }   
    }
}
</script>

<style>
    .is-valid {color:#0a8927;}

    .custom-control-input.is-valid ~ .custom-control-label {
        color: #408600;
    }

    .custom-control-input.is-valid:checked ~ .custom-control-label::before {
        border-color: #408600;
        background-color: #408600;
    }


</style>
